import React from 'react'
import * as R from 'ramda'
import { jt, t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'
import { Detail } from 'components/shared/Detail/Detail'

import { useDeleteCandidateGroupModalState } from './hooks'

import styles from './DeleteCandidateGroupModal.module.scss'

export const DeleteCandidateGroupModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const { state } = useDeleteCandidateGroupModalState()

  const { candidates, count, pks } = state

  const message = R.gt(R.length(pks), 0) ? (
    <Detail className={styles.detail} key="candidates">
      <Detail.Content
        chipsClassName={styles.content}
        chips={R.map(({ name }) => name, candidates)}
        type="chipsGroup"
      />
    </Detail>
  ) : null

  return (
    <DeleteResourceModal
      alert={jt`You are deleting ${count} candidates listed below: ${message}`}
      className={styles.modal}
      message={t`Are you sure you want to delete?`}
      title={t`Delete candidates`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
